// src/components/generic-crud/GenericToolbar.js
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { Stack, TextField, IconButton, InputAdornment, Button, Tooltip } from '@mui/material';
import Iconify from 'src/components/iconify';

export default function GenericToolbar({
  config,
  filters,
  onFilters,
  onAdvancedFilters,
  onImport,
  onExport,
  features,
}) {
  const searchField = config.fields.find((f) => f.type === 'search');

  const handleFilterSearch = useCallback(
    (event) => {
      if (searchField) {
        onFilters(searchField.name, event.target.value);
      }
    },
    [onFilters, searchField]
  );

  const hasAdvancedFilters = config.fields.some((f) => f.inAdvancedFilters);

  return (
    <Stack
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{ xs: 'column', md: 'row' }}
      sx={{ p: 2.5, pr: { xs: 2.5, md: 1 } }}
    >
      <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1 }}>
        {searchField && (
          <TextField
            fullWidth
            value={filters[searchField.name] || ''}
            onChange={handleFilterSearch}
            placeholder={searchField.placeholder}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                </InputAdornment>
              ),
            }}
          />
        )}

        {hasAdvancedFilters && (
          <Button
            variant="outlined"
            color="inherit"
            startIcon={<Iconify icon="solar:filter-bold" />}
            onClick={onAdvancedFilters}
          >
            Filters
          </Button>
        )}
      </Stack>

      <Stack direction="row" spacing={1} flexShrink={0}>
        {features.export && (
          <Tooltip title="Export">
            <IconButton onClick={onExport}>
              <Iconify icon="solar:export-bold" />
            </IconButton>
          </Tooltip>
        )}
        {features.import && (
          <Tooltip title="Import">
            <IconButton onClick={onImport}>
              <Iconify icon="solar:import-bold" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
}

GenericToolbar.propTypes = {
  config: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  onFilters: PropTypes.func.isRequired,
  onAdvancedFilters: PropTypes.func,
  onImport: PropTypes.func,
  onExport: PropTypes.func,
  features: PropTypes.object,
};
